import React from "react";
import { Form, Input, Button } from "antd";

const StarLabelInputBox = ({ label, }) => {
  // console.log(important)
  return (
    <div className="d-flex gap-4">
      <Form.Item
        label={label}
        name={label}
        rules={[
          {
            required: false,
            message: "Please input your first name!",
          },
        ]}
        className="form_label"
      ></Form.Item>
      <Input className="w-100 inputbox" />
    </div>
  );
};

export default StarLabelInputBox;
